<template>
  <div class="slide boxes_hand zoom" ref="boxes_hand" v-parallax-fit="boxes_hand">
    <div class="boxes"></div>
    <div class="hand" v-parallax-fit="hand"></div>
  </div>

</template>

<script>
export default {
  name: 'slide19',
  data() {
    return {
      boxes_hand: [
        {
          start: 20000,
          end: 20700,
          fromStyle: { transform: 'translateX(1600px) translateY(0px)' },
          toStyle: { transform: 'translateX(-270px) translateY(0px)' },
          easing: 'linear'
        },
        {
          start: 23000,
          end: 23700,
          fromStyle: { transform: 'translateY(0px)' },
          toStyle: { transform: 'translateY(1600px)' },
          easing: 'linear'
        },
      ],
      hand: [
        {
          start: 21700,
          end: 22700,
          fromStyle: { transform: 'translateX(0px)' },
          toStyle: { transform: 'translateX(1400px)' },
          easing: 'linear'
        },
      ],
    };
  },
}
</script>

<style lang="scss" scoped>
.boxes_hand {
  width:100%;
  height: 100%;
  position: fixed;
  z-index: 4;
  transition: 1s;
  pointer-events: none;
}
.boxes {
    position: fixed;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/MovingBoxes.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 800px;
    height: 670px;
    left: calc(50% - 289px);
    top: calc(50% - 371px);
    transition: 0.6s;
    z-index: 4;
    @media(max-width: 600px) {
      width: 80vw;
      left: 10%;
    }
}
.hand {
    position: fixed;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/MovingHand.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 940px;
    height: 300px;
    left: calc(50% + 344px);
    top: calc(50% - 113px);
    transition: 1s;
    z-index: 4;
    @media(max-width:600px) {
      width: 590px;
      left: 69%;
      top: calc(50% - 143px);
    }
}
</style>
